
import PrismicData from '~/assets/js/prismic-controller.js'
import FaqSearch from '~/components/faq/FaqSearch.vue'
import faq from '~/assets/data/faq'
export default {
  name: 'FAQ',
  nuxtI18n: {
    paths: {
      en: '/faq',
      it: '/faq',
      de: '/faq'
    },
  },
  layout: 'faq',
  data() {
    return {
      products: faq.products
    }
  },
  components: {
    FaqSearch,
  },
  head() {
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), this.document, this.documentUid, this.documentLang)
  },
  async asyncData({ $prismic, app, error, req, store }) {
    const lang = app.i18n.locales.filter((i) =>
      i.iso.includes(app.i18n.locale)
    )[0].iso
    try {
      const result = await $prismic.api.getSingle('faq_page', { lang })
      return {
        document: result.data,
        documentUid: result.uid,
        documentLang: result.lang.substr(0, 2),
      }
    } catch (e) {
      error({ message: JSON.stringify(e), statusCode: 404 })
    }
  },
}
